import Circular from "./Circular";
import Path from "./Path";
import Props from "./props";
import React from "react";
import Wrapper from "./Wrapper";

const Loader: React.FC<Props> = ({ primary, light }) => {
    return (
        <Wrapper>
            <Circular viewBox="25 25 50 50">
                <Path primary={primary} light={light} cx="50" cy="50" r="20" fill="none" strokeWidth="3" strokeMiterlimit="10" />
            </Circular>
        </Wrapper>
    );
};

export default Loader;
